import React, { useEffect, useState } from "react";
import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import LoadingContainer from "../layouts/LoadingContainer";
import { endOfDay } from "date-fns";
import { useMobile } from "../utils/mobile";
import ReportDetails from "./ReportDetails";
import ReportDetailsMobile from "./ReportDetailsMobile";

const ReportDetailsMain = ({ userStore, reportDetailsStore }) => {
  const { t } = useTranslation("report_details");
  const [isLoading, setLoading] = useState(false);
  const [reportDetails, setReportDetails] = useState([]);
  const [date, setDate] = useState([null, null]);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [selectedReport, setSelectedReport] = useState({});
  const [inSearch, setInSearch] = useState(false);
  const isMobile = useMobile();

  useEffect(() => {
    const fetchReportDetails = async () => {
      setLoading(true);
      reportDetailsStore.setError("");
      await reportDetailsStore.getReportDetails(userStore.userDetails);
      if (!!reportDetailsStore.error) {
        setError(reportDetailsStore.error);
      }
      setReportDetails(reportDetailsStore.reportDetails || []);
      setLoading(false);
    };
    fetchReportDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const filteredDate = reportDetailsStore.reportDetails.filter((report) => {
      var toDate = new Date(date[1]);
      toDate = endOfDay(toDate);

      return (
        (date[0] !== null
          ? new Date(report.CURDATE).getTime() >= new Date(date[0]).getTime()
          : true) &&
        (date[1] !== null
          ? toDate.getTime() >= new Date(report.CURDATE).getTime()
          : true)
      );
    });
    const filteredSearch = search
      ? filteredDate.filter((report) => {
          return (
            report.CUSTDES?.includes(search) ||
            report.ORDNAME?.includes(search) ||
            report.PARTDES?.includes(search) ||
            report.JOBDESC?.includes(search) ||
            report.ANSWER?.includes(search) ||
            report.QDES?.includes(search)
          );
        })
      : filteredDate;

    if (!search && !date[0] && !date[1]) {
      setInSearch(false);
    }

    setReportDetails(filteredSearch);
  }, [search, date, reportDetailsStore.reportDetails]);

  const handelRowClick = (report) => {
    const reportData = {
      REPORT: report.REPORT,
      LINE: report.LINE,
      data: {
        CURDATE: report.CURDATE,
        CUSTNAME: report.CUSTNAME,
        CUSTDES: report.CUSTDES,
        ORDNAME: report.ORDNAME,
        DETAILS: report.DETAILS,
        PARTDES: report.PARTDES,
        PDES: report.PDES,
        OLINE: report.OLINE,
        JOBDESC: report.JOBDESC,
        HOURS: report.HOURS,
        QDES: report.QDES,
        ANSWER: report.ANSWER,
        ZCOR_TASKNAME: report.ZCOR_TASKNAME,
        ZCOR_TASKDES: report.ZCOR_TASKDES,
        DOCNO: report.ZCOR_DOCNO,
        FREEOFCHARGE: report.FREEOFCHARGE,
      },
    };
    setSelectedReport(reportData);
  };

  const handelOpenNewReportClick = (report) => {
    setSelectedReport({});
  };

  const handelRowDeleteClick = async (e, report) => {
    e.stopPropagation();
    setLoading(true);
    reportDetailsStore.setError("");
    await reportDetailsStore.deleteReport(report);
    if (!!reportDetailsStore.error) {
      setError(reportDetailsStore.error);
    }
    setLoading(false);
  };

  const handleSearchChange = (search) => {
    setSearch(search);
    setInSearch(true);
  };

  const handleDateChange = (date) => {
    if (date?.length > 0) {
      setDate([date[0].startDate, date[0].endDate]);
    } else {
      setDate([null, null]);
    }

    setInSearch(true);
  };

  return (
    <LoadingContainer isLoading={isLoading}>
      {isMobile ? (
        <ReportDetailsMobile
          reportDetails={reportDetails}
          selectedReport={selectedReport}
          handelRowClick={handelRowClick}
          handelRowDeleteClick={handelRowDeleteClick}
          handelOpenNewReportClick={handelOpenNewReportClick}
          handleSearchChange={handleSearchChange}
          handleDateChange={handleDateChange}
          inSearch={inSearch}
          date={date}
          error={error}
        />
      ) : (
        <ReportDetails
          reportDetails={reportDetails}
          selectedReport={selectedReport}
          handelRowClick={handelRowClick}
          handelRowDeleteClick={handelRowDeleteClick}
          handelOpenNewReportClick={handelOpenNewReportClick}
          handleSearchChange={handleSearchChange}
          handleDateChange={handleDateChange}
          inSearch={inSearch}
          error={error}
        />
      )}
    </LoadingContainer>
  );
};

export default inject(
  "userStore",
  "reportDetailsStore"
)(observer(ReportDetailsMain));
